const TimeCountDown = function (selector) {

    let elem = $(document).find(selector);

    let options = {
        finish: function () {
            console.log('Countdown finished');
        }
    };

    Object.defineProperties(this, {
        element: {
            get: function () {
                return elem;
            }
        },
        finish: {
            get: function () {
                return options.finish;
            },
            set: function (fn) {
                if (isFunction(fn)) {
                    options.finish = fn;
                }
            }
        }
    });

};

TimeCountDown.prototype.init = function () {

    let self = this;

    if (isDefined(this.element.data('initialized'))) {
        return;
    }

    if (this.element.length) {

        setInterval(function () {

            let now = new Date().getTime();
            let endDate = new Date(self.element.data('end-date'));

            let difference = endDate - now;

            // Time calculations for days, hours, minutes and seconds
            let hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            let minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
            let seconds = Math.floor((difference % (1000 * 60)) / 1000);

            if (hours > 0 || minutes > 0 || seconds > 0) {

                if (hours < 10) {
                    hours = '0' + hours;
                }

                if (minutes < 10) {
                    minutes = '0' + minutes;
                }

                if (seconds < 10) {
                    seconds = '0' + seconds;
                }

                self.element.text(hours + ":" + minutes + ":" + seconds);

            } else {
                self.finish();
            }

        }, 1000);

    }

    this.element.data('initialized', true);

};

$(document).ready(function () {

    let header = $('header');
    let topBar = $('.navbar.top-bar');
    let menuBar = $('.navbar.menu-bar');
    let mainMenu = $('#main-menu');
    let main = $('body');

    main.css('padding-top', header.outerHeight());
    if ($(window).scrollTop() > 0) {
        main.css('padding-top', header.outerHeight());
    }

    let userDropDown = $('#user-drop-down');

    if (userDropDown.length) {
        let userDropDownInstance = new DropDown(userDropDown, userDropDown.closest('.navbar-item'));
        userDropDownInstance.init();
    }

    $(window).on('scroll resize', function (e) {

        main.css('padding-top', header.outerHeight());

        if (window.matchMedia('(min-width: 1200px)').matches) {
            mainMenu.css({
                'top': 'unset',
                'height': 'unset'
            });
        } else {
            if (mainMenu.hasClass('visible')) {
                mainMenu.css({
                    'top': topBar.outerHeight() + menuBar.outerHeight(),
                    'height': $(window).height() - (topBar.outerHeight() + menuBar.outerHeight())
                });
            }
        }

    });

    $(document).on('click', '.navbar .hamburger', function (e) {

        let target = $(this).data("target");

        if (isDefined(target)) {

            target = $(document).find(target);
            $(this).toggleClass('active');

            target.css({
                'top': topBar.outerHeight() + menuBar.outerHeight(),
                'height': $(window).height() - (topBar.outerHeight() + menuBar.outerHeight())
            });

            let nowVisible = target.hasClass('visible');

            if (nowVisible) {
                target.removeClass('visible');
            } else {
                target.addClass('visible');
            }

        }

    });

});
